import { render, staticRenderFns } from "./recupararSenha.vue?vue&type=template&id=6ab0aa40&scoped=true&"
import script from "./recupararSenha.vue?vue&type=script&lang=js&"
export * from "./recupararSenha.vue?vue&type=script&lang=js&"
import style0 from "./recupararSenha.vue?vue&type=style&index=0&id=6ab0aa40&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab0aa40",
  null
  
)

export default component.exports